import { CoreText } from '@/components/Theme/Core/CoreText';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const Center = withStyles(CoreText, {noSwitch: true, style: { flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'flex'}});